import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkQueryParams } from "../../utility/other";
import styles from "./index.module.scss";

function AccessDenied() {
  const navigate = useNavigate();
  const hasQueryParams = checkQueryParams(window.location.href, "?");

  useEffect(() => {
    if (hasQueryParams) {
      setTimeout(() => {
        localStorage.clear();
        navigate("/login");
      }, 3000);
    }
  }, []);

  return (
    <div
      className={styles["access-denied-wrapper"]}
      style={{ height: hasQueryParams ? "100vh" : "94.5vh" }}
    >
      <div className={styles["title"]}>Access Denied</div>
      <div className={styles["message"]}>
        You do not have permission to access to this{" "}
        {hasQueryParams ? "website. Redirecting to Login Page..." : "page"}.
      </div>
    </div>
  );
}

export default AccessDenied;
